import { cn } from "@/lib/utils";

interface ConflictBadgeProps {
  totalUsed: number;
  availableQuantity: number | null;
  isSerialized: boolean;
  hasConflict: boolean;
  onClick: () => void;
}

export function ConflictBadge({
  totalUsed,
  availableQuantity,
  isSerialized,
  hasConflict,
  onClick,
}: ConflictBadgeProps) {
  // Don't show if no availability info
  if (availableQuantity === null) {
    return null;
  }

  // For serialized equipment, use hasConflict from hook (based on instance overlap)
  // For non-serialized, use quantity comparison
  const isOverAllocated = isSerialized
    ? hasConflict
    : totalUsed > availableQuantity;
  const isNearCapacity =
    !isOverAllocated && !isSerialized && totalUsed > availableQuantity * 0.8;

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium transition-colors",
        "hover:opacity-80 cursor-pointer",
        isOverAllocated && "bg-destructive/15 text-destructive",
        isNearCapacity &&
          "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
        !isOverAllocated && !isNearCapacity && "bg-muted text-muted-foreground",
      )}
    >
      {totalUsed}/{availableQuantity}
    </button>
  );
}
